import { base } from "@base-provider";

export const getSelectOptions = async (url, urlData) => {
  return base.post({ url: url, data: urlData });
};